/**
 * Coerce a value that may be loosely typed (e.g. strings from Postgres) into a boolean.
 * Handles common truthy/falsey string and numeric representations while defaulting to false
 * for null/undefined inputs.
 */
export const coerceBoolean = (value: unknown): boolean => {
  if (typeof value === 'boolean') {
    return value;
  }

  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();

    if (normalized === '') {
      return false;
    }

    if (['true', 't', '1', 'yes', 'y'].includes(normalized)) {
      return true;
    }

    if (['false', 'f', '0', 'no', 'n'].includes(normalized)) {
      return false;
    }
  }

  if (typeof value === 'number') {
    return value !== 0;
  }

  if (value == null) {
    return false;
  }

  return Boolean(value);
};
